import {
  VeteranAutoPriceRequestInfo,
  VeteranAutoProductDetailsFormValues,
  VeteranAutoProductIntroFormValues,
  VeteranAutoProductPriceFormValues,
} from "./veteranAutoInterface";

import { Option } from "@storeblocks/radio";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { VeteranModel } from "Store/getVeteranVehicleModel/interfaces";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { VeteranAutoType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/VeteranAuto";
import { formBooleanToBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";

export function mapFormToPriceRequest(
  formValuesIntro: VeteranAutoProductIntroFormValues,
  formValuesDetails: VeteranAutoProductDetailsFormValues,
  formValuesPrice: VeteranAutoProductPriceFormValues | undefined,
): VeteranAutoPriceRequestInfo {
  return {
    conditionCheck: formBooleanToBoolean(formValuesIntro.isInGoodCondition),
    brand: formValuesIntro.veteranAutoType,
    model: formValuesIntro.modelAndValue,
    modelDescription: formValuesIntro.brandOrModel,
    registrationYear: String(formValuesIntro.firstRegistered),
    insuranceHolderIsVeteranAutoOwner: formBooleanToBoolean(
      formValuesDetails.insuranceHolderIsOwner,
    ),
    ...(formValuesDetails.insuranceHolderIsOwner === BooleanFormType.FALSE
      ? { relation: formValuesDetails.relation, age: formValuesDetails.age }
      : {}),
    isMemberOfVeteranClub: formBooleanToBoolean(
      formValuesPrice?.isMemberOfVeteranClub ?? BooleanFormType.FALSE,
    ),
    injuries: Number(formValuesDetails.injuries),
    injuryYear:
      formValuesDetails.injuries !== DamageRecentYears.NONE
        ? formValuesDetails.injuryYear
        : undefined,
  };
}

export const getVeteranAutoTypeOptions = (): Option[] => [
  {
    id: VeteranAutoType.VETERANBIL,
    label: "Veteranbil",
    value: VeteranAutoType.VETERANBIL,
  },
  {
    id: VeteranAutoType.VETERANMOPED,
    label: "Veteranmoped",
    value: VeteranAutoType.VETERANMOPED,
  },
  {
    id: VeteranAutoType.VETERANMOTORSYKKEL,
    label: "Veteranmotorsykkel",
    value: VeteranAutoType.VETERANMOTORSYKKEL,
  },
];

export const mapVeteranModelsToOptions = (
  models: VeteranModel[] | null,
): Option[] => {
  if (!isDefined(models)) {
    return [];
  }
  return models.map((model) => ({
    id: model.name,
    label: model.name,
    value: model.name,
  }));
};
